module.exports = __webpack_public_path__ + "img/banner.cb8f8b49.png";